module.exports = __webpack_public_path__ + "static/media/prop-72.3f22f000.png";


//////////////////
// WEBPACK FOOTER
// ./src/pages/june-5/props/images/prop-72.png
// module id = 640
// module chunks = 0 32 33